module.exports = __webpack_public_path__ + "media/new/pay-manual-bc6b55a1.svg";